/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取当前城市是否包含项目
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  cityCode: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/dictionary/place/city/product/${cityCode}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
